import React from 'react'
import Modal from 'react-bootstrap/Modal';
import { CloseIcon } from '../../assets/icons/iconshere';
import ABG from '../../assets/images/pro/abg.png'
import Hp from '../../assets/images/pro/hp.png'
import Jj from '../../assets/images/pro/jj.png'
import Piramal from '../../assets/images/pro/piramal.png'
import Ya from '../../assets/images/pro/ya.png'
import Cairn from '../../assets/images/pro/cairn.png'
import TuvSud from '../../assets/images/pro/tuvsud.png'
import Lupin from '../../assets/images/pro/lupin.png'
import Merc from '../../assets/images/pro/merc.png';
import PopupBG from '../../assets/images/pro/Dashboard.jpg'
import PopupBGReports from '../../assets/images/pro/Dashboard.jpg'
import ProupDash from '../../assets/images/pro/Dashboard.jpg'
import ProupReport from '../../assets/images/pro/Report.png'
import ProupKPI from '../../assets/images/pro/KPI.png'


const ProPopup = ( { openPro, setOpenPro , proType}) => {

    const body = document.body;
  
     if (openPro) {
        body.classList.add('propopup-active');
      } else {
        body.classList.remove('propopup-active');
      }
    
  return (
    <>

      <Modal
        centered
        show={openPro}
        onHide={() => setOpenPro(false) }
        className='PopupModal'
      >

       <div className='pro-detail-box'>
            {/* <div className='upper'> */}
            <div className='detail-side'>
                <div className='text-parent'>
                <div className='text-detail'>
                    <h5> Go Pro to unlock all the features.</h5>
                    <h6>Enhance your Team's Performance with Comprehensive Insights.</h6>
                </div>
                <div className='text-list-detail'>
                    <ul>
                        <li>
                            <strong> Team Analytics </strong>  Gain deep insights into your team's progress and performance.
                        </li>
                        <li>
                            <strong> Real-time Monitoring </strong> Track your team's activities in real-time for swift decision-making.
                        </li>
                        <li>
                            <strong> Custom Dashboard </strong> Customize your dashboard to align with your team's unique needs.
                        </li>
                        <li>
                            <strong> Interactive Visuals </strong> Dive into interactive charts for in-depth analysis of team data.
                        </li>
                    </ul>
                </div>
                <span className='d-flex align-items-center justify-content-start w-100'>
                <button className='pro-btn'>Upgrade to Pro</button>
                </span>
                </div>
                   <div className='bottom'>
                <div className='company-text'>
                Used by <br/> top companies
                </div>
                <div className='company-logos'>
                    <img src={ABG}/>
                    <img src={Cairn}/>
                    <img src={Merc}/>
                    <img src={Ya}/>
                    <img src={TuvSud}/>
                </div>
            </div>
            </div>
            <div className='media-side'>
                <img src={ProupDash}/>
            </div>
            <span className='close-icon' onClick={() => setOpenPro(false)}>
                <CloseIcon/>    
            </span>   
            {/* </div> */}
         
             
           
       </div>
      </Modal>


     {/* {proType == "kpi" &&
      <Modal
        centered
        show={openPro}
        onHide={() => setOpenPro(false) }
        className='PopupModal'
      >

       <div className='pro-detail-box'>
            <div className='detail-side'>
                <div className='text-parent'>
                <div className='text-detail'>
                    <h5> Go Pro to unlock all the features.</h5>
                    <h6>Level up your Learning with detailed statistics.</h6>
                </div>
                <div className='text-list-detail'>
                    <ul>
                        <li>
                            <strong> Insights </strong> Detailed KPIs for instant performance understanding.
                        </li>
                        <li>
                            <strong> Monitoring </strong>  Real-time KPI tracking for quick decisions.
                        </li>
                        <li>
                            <strong> Customization </strong> Tailor dashboards to your needs.
                        </li>
                        <li>
                            <strong> Visualization </strong> Interactive charts for deeper data analysis.
                        </li>
                    </ul>
                </div>
                <span className='d-flex align-items-center justify-content-start w-100'>
                <button className='pro-btn'>Upgrade to Pro</button>
                </span>
                </div>
                   <div className='bottom'>
                <div className='company-text'>
                Used by <br/> top companies
                </div>
                <div className='company-logos'>
                    <img src={ABG}/>
                    <img src={Cairn}/>
                    <img src={Merc}/>
                    <img src={Ya}/>
                    <img src={TuvSud}/>
                </div>
            </div>
            </div>
            <div className='media-side'>
                <img src={ProupKPI}/>
            </div>
            <span className='close-icon' onClick={() => setOpenPro(false)}>
                <CloseIcon/>    
            </span>            
           
       </div>
      </Modal>
      }
   
     {proType == "reports" &&
      <Modal
        centered
        show={openPro}
        onHide={() => setOpenPro(false) }
        className='PopupModal'
      >

       <div className='pro-detail-box'>
            <div className='detail-side'>
                <div className='text-parent'>
                <div className='text-detail'>
                    <h5> Go Pro to unlock all the features.</h5>
                    <h6>Empower Your Decision-Making with Comprehensive Reports.</h6>
                </div>
                <div className='text-list-detail'>
                    <ul>
                        <li>
                            <strong> Detailed Insights </strong>  Access detailed reports on groups, subgroups, and individual users.
                        </li>
                        <li>
                            <strong> Certification </strong>   Status Track the number of certified users for each course or training program.
                        </li>
                        <li>
                            <strong> Customizable </strong>  Downloads Download reports tailored to your specific requirements.
                        </li>
                        <li>
                            <strong> Effortless Decision-Making </strong>  Equip yourself with actionable data for informed decision-making."
                        </li>
                    </ul>
                </div>
                <span className='d-flex align-items-center justify-content-start w-100'>
                <button className='pro-btn'>Upgrade to Pro</button>
                </span>
                </div>
                   <div className='bottom'>
                <div className='company-text'>
                Used by <br/> top companies
                </div>
                <div className='company-logos'>
                    <img src={ABG}/>
                    <img src={Cairn}/>
                    <img src={Merc}/>
                    <img src={Ya}/>
                    <img src={TuvSud}/>
                </div>
            </div>
            </div>
            <div className='media-side'>
            <img src={ProupReport}/>
            </div>
            <span className='close-icon' onClick={() => setOpenPro(false)}>
                <CloseIcon/>    
            </span>        
           
       </div>
      </Modal>
      } */}
    

    </>
  )
}

export default ProPopup